import React from "react";
import PatientDetails from "../PatientDetails";

const HealthVitals = () => {
  return (
    <div>
      <PatientDetails />
    </div>
  );
};

export default HealthVitals;
